import * as React from "react";
import PropTypes from "prop-types";

const Star = ({visible, title}) => visible ? <span title={title}>*</span> : null;
Star.propTypes = {
	visible: PropTypes.bool,
	title: PropTypes.string
};

export default Star;